<template>
  <b-row>
    <b-col cols="12">
      <b-card
        :img-src="bannerImg"
        overlay
        text-variant="white"
        img-alt="card img"
        img-height="200"
      >
        <b-card-title class="text-white pt-2 pl-2 mb-0">
          PCC
        </b-card-title>
        <b-card-text class="p-2">
          <p>
            {{pcc}}
          </p>
        </b-card-text>
      </b-card>
    </b-col>

    <b-col cols="12" class="mb-2">
      <pcc-cards />
    </b-col>

    <b-col cols="12">
      <b-card title="PCC Requests">
        <pcc-request-table />
      </b-card>
    </b-col>
  </b-row>
</template>

<script>
import { BRow, BCol, BCard, BCardText, BCardTitle } from 'bootstrap-vue'
import PCCCards from '@/views/user/pcc/PCCCards.vue'
import PccRequestTable from '@/views/user/pcc/PCCRequestTable.vue'

export default {
  components: {
    BRow,
    BCol,
    BCard,
    BCardText,
    BCardTitle,
    PccCards: PCCCards,
    PccRequestTable,
  },

  data() {
    return {
      pcc: '',
      bannerImg: require('@/assets/images/product_banner-old.png'),
    }
  },

  mounted() {
    this.$http.get('/settings/product')
      .then(res => {
        this.pcc = res.data.data.pcc
      })
      .catch(err => { this.$notif('Error', `${err.message}`, 'error') })
  },

  methods: {
    //
  },
}
</script>
